import { render, staticRenderFns } from "./Suscripciones.vue?vue&type=template&id=54615097"
import script from "./Suscripciones.vue?vue&type=script&lang=js"
export * from "./Suscripciones.vue?vue&type=script&lang=js"
import style0 from "./Suscripciones.vue?vue&type=style&index=0&id=54615097&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports